var ThemeService = /** @class */ (function () {
    function ThemeService() {
        this.themes = ['lightTheme', 'darkTheme', 'orangeTheme'];
    }
    Object.defineProperty(ThemeService.prototype, "theme", {
        get: function () {
            return this.current;
        },
        enumerable: true,
        configurable: true
    });
    ThemeService.prototype.initTheme = function () {
        if (this.current === undefined) {
            this.current = JSON.parse(localStorage.getItem('theme')) || this.themes[0];
        }
        if (this.current) {
            this.setTheme(this.current);
        }
    };
    ThemeService.prototype.changeTheme = function (name) {
        if (this.themes.indexOf(name) >= 0) {
            this.setTheme(name);
        }
        else {
            this.clean();
        }
    };
    ThemeService.prototype.clean = function () {
        for (var _i = 0, _a = this.themes; _i < _a.length; _i++) {
            var theme = _a[_i];
            document.documentElement.classList.remove(theme);
        }
    };
    ThemeService.prototype.setTheme = function (name) {
        localStorage.setItem('theme', JSON.stringify(name));
        this.clean();
        document.documentElement.classList.add(name);
    };
    return ThemeService;
}());
export { ThemeService };



// WEBPACK FOOTER //
// ./src/app/core/theme.service.ts.pre-build-optimizer.js